/**
 * Conciliacion Bancaria API Service
 */
import api from './api';

const API_BASE_URL = (() => {
  const baseURL = api?.defaults?.baseURL || '/api/content';
  return baseURL.replace(/\/content\/?$/i, '/contabilidad');
})();

const conciliacionService = {
  getAll: (filters = {}) => api.get(`${API_BASE_URL}/conciliaciones/`, { params: filters }),
  getById: (id) => api.get(`${API_BASE_URL}/conciliaciones/${id}/`),
  create: (data) => api.post(`${API_BASE_URL}/conciliaciones/`, data),
  importarCartola: (id, formData) => api.post(`${API_BASE_URL}/conciliaciones/${id}/importar-cartola/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  conciliarAuto: (id) => api.post(`${API_BASE_URL}/conciliaciones/${id}/conciliar-auto/`),
  conciliarManual: (id, data) => api.post(`${API_BASE_URL}/conciliaciones/${id}/conciliar-manual/`, data),
  cerrar: (id) => api.post(`${API_BASE_URL}/conciliaciones/${id}/cerrar/`),
};

export default conciliacionService;
